import React, { useEffect, useState } from 'react';

// import './styles.css';

import nfeServices from '../../../../../services/admFin/nfeServices';

import Popup from '../../../../../components/Popup';
import Input from '../../../../../components/Input';
import { FaFileInvoiceDollar } from 'react-icons/fa';
import { Dots } from 'react-activity';

function PopupNFe(props) {
    const [id, setId] = useState("");
    const [natureOfOperation, setNatureOfOperation] = useState("");
    const [issueDate, setIssueDate] = useState("");
    const [documentType, setDocumentType] = useState("");
    const [destination, setDestination] = useState("");
    const [purposeOfIssuance, setPurposeOfIssuance] = useState("");
    const [finalCostumer, setFinalCostumer] = useState("");
    const [buyerPresence, setBuyerPresence] = useState("");
    const [shippingMode, setShippingMode] = useState("");
    const [freightValue, setFreightValue] = useState(0.0);
    const [discountValue, setDiscountValue] = useState(0.0);
    const [insuranceValue, setinsuranceValue] = useState(0.0);
    const [fetching, setFetching] = useState(false);

    const cleanStates = () => {
        setId("");
        setNatureOfOperation("");
        setIssueDate("");
        setDocumentType("");
        setDestination("");
        setPurposeOfIssuance("");
        setFinalCostumer("");
        setBuyerPresence("");
        setShippingMode("");
        setFreightValue(0.0);
        setDiscountValue(0.0);
        setinsuranceValue(0.0);
        setFetching(false);
    }

    useEffect(() => {
        if(!props.visibility)
            cleanStates();
    }, [props.visibility]);

    useEffect(() => {
        if(props.bill && props.bill.id){
            console.log(props.bill.id);
            setId(props.bill.id);
        }
    }, [props.bill]);

    const onRegister = async () => {
        setFetching(true);
        try{
            if( natureOfOperation && issueDate && documentType && destination && purposeOfIssuance && finalCostumer &&
                buyerPresence && shippingMode /* && freightValue && discountValue && insuranceValue */){
                    const response = await nfeServices.postNfeBill(id,
                        natureOfOperation,
                        issueDate,
                        nfeServices.tipos_documento.find(obj => obj[1] === documentType)[0],
                        nfeServices.locais_destino.find(obj => obj[1] === destination)[0],
                        nfeServices.finalidades_emissao.find(obj => obj[1] === purposeOfIssuance)[0],
                        nfeServices.consumidores_finais.find(obj => obj[1] === finalCostumer)[0],
                        nfeServices.tipos_presenca_comprador.find(obj => obj[1] === buyerPresence)[0],
                        nfeServices.tipos_modalidade_frete.find(obj => obj[1] === shippingMode)[0],
                        discountValue,
                        insuranceValue
                        )
                    props.setVisibility(false);
                }
            else{
                alert("Todos os campos obrigatórios devem estar preenchidos!");
            }

        } catch(err){
            alert("Erro ao registrar nota fiscal!");
        }
        setFetching(false);
    }
    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            icon={<FaFileInvoiceDollar />}
            tittle="Gerar NFe"
        >
            <form>
                <Input
                    label='Natureza da operação*'
                    placeholder="Selecione a natureza da operação"
                    id='popup-nfe-nature-of-operation'
                    onChange={(event) => setNatureOfOperation(event.target.value)}
                    value={natureOfOperation}
                />

                <Input
                    label='Data de emissão*'
                    type="date"
                    placeholder="Selecione a data de emissão"
                    id='popup-nfe-issue-date'
                    onChange={(event) => setIssueDate(event.target.value)}
                    value={issueDate}
                />

                <Input
                    label='Tipo do documento*'
                    type="select"
                    options={nfeServices.tipos_documento.map(item => item[1])}
                    id='popup-nfe-document-type'
                    placeholder="Selecione o tipo do documento"
                    onChange={(event) => setDocumentType(event.target.value)}
                    value={documentType}
                />

                <Input
                    label='Local de destino*'
                    type="select"
                    options={nfeServices.locais_destino.map(item => item[1])}
                    id='popup-nfe-destination'
                    placeholder="Selecione o local de destino"
                    onChange={(event) => setDestination(event.target.value)}
                    value={destination}
                />

                <Input
                    label='Finalidade da emissão*'
                    type="select"
                    options={nfeServices.finalidades_emissao.map(item => item[1])}
                    id='popup-nfe-purpose-of-issuance'
                    placeholder="Selecione a finalidade da emissão"
                    onChange={(event) => setPurposeOfIssuance(event.target.value)}
                    value={purposeOfIssuance}
                />

                <Input
                    label='Consumidor final*'
                    type="select"
                    options={nfeServices.consumidores_finais.map(item => item[1])}
                    id='popup-nfe-final-costumer'
                    placeholder="Selecione o consumidor final"
                    onChange={(event) => setFinalCostumer(event.target.value)}
                    value={finalCostumer}
                />

                <Input
                    label='Presenca do comprador*'
                    type="select"
                    options={nfeServices.tipos_presenca_comprador.map(item => item[1])}
                    id='popup-nfe-buyer-presence'
                    placeholder="Selecione a presenca do comprador"
                    onChange={(event) => setBuyerPresence(event.target.value)}
                    value={buyerPresence}
                />

                <Input
                    label='Modalidade do frete*'
                    type="select"
                    options={nfeServices.tipos_modalidade_frete.map(item => item[1])}
                    id='popup-nfe-shipping-mode'
                    placeholder="Selecione a modalidade do frete"
                    onChange={(event) => setShippingMode(event.target.value)}
                    value={shippingMode}
                />

                <Input
                    label="Valor do frete"
                    type='currency'
                    currency={props.bill ? props.bill.moeda : null}
                    id='popup-nfe-freight-value'
                    onChange={(event) => setFreightValue(event.target.value)}
                    value={freightValue}
                />

                <Input
                    label="Valor do desconto"
                    type='currency'
                    currency={props.bill ? props.bill.moeda : null}
                    id='popup-nfe-discount-value'
                    onChange={(event) => setDiscountValue(event.target.value)}
                    value={discountValue}
                />

                <Input
                    label="Valor do seguro"
                    type='currency'
                    currency={props.bill ? props.bill.moeda : null}
                    id='popup-nfe-insurance-value'
                    onChange={(event) => setinsuranceValue(event.target.value)}
                    value={insuranceValue}
                />

                <button
                    type="button"
                    className="green"
                    onClick={() => fetching ? alert("Um envio já está em andamento.") : onRegister()}
                >
                    {
                        fetching ?
                            <Dots />
                            : "Registrar"
                    }
                </button>
            </form>
        </Popup>
    );
}

export default PopupNFe;